export function treeReduce(nodes, fn, initialValue, childName = 'children', parentNode) {
    return nodes.reduce((previousValue, node, index) => {
        const newValue = fn(previousValue, node, index, parentNode);
        const children = node[childName];
        if (children && children.length) {
            return treeReduce(children, fn, newValue, childName, node);
        }
        return newValue;
    }, initialValue);
}
export function treeForEach(nodes, fn, childName = 'children', parentNode) {
    nodes.forEach((node, index) => {
        fn(node, index, parentNode);
        const children = node[childName];
        if (children && children.length) {
            treeForEach(children, fn, childName, node);
        }
    });
}
export function treeSome(nodes, fn, childName = 'children', parentNode) {
    return nodes.some((node, index) => {
        if (!fn(node, index, parentNode)) {
            const children = node[childName];
            if (children && children.length) {
                return treeSome(children, fn, childName, node);
            }
        }
        return true;
    });
}
export function treeFind(nodes, fn, childName = 'children', parentNode) {
    let result;
    nodes.some((node, index) => {
        const found = fn(node, index, parentNode);
        if (found) {
            result = node;
            return true;
        }
        const children = node[childName];
        if (children && children.length) {
            const foundChild = treeFind(children, fn, childName, node);
            if (foundChild) {
                result = foundChild;
                return true;
            }
        }
        return false;
    });
    return result;
}
